export default __webpack_public_path__ + "static/wms-integration-for-seamless-efficiency-d7c4e6f7adb867eaf5e1091d9c3b9794.png";